export default __webpack_public_path__ + "static/media/balsa.6b33c329.svg";